import { Component } from '@angular/core';
import { AuthService } from '../../account/auth.service'
import { Router } from '@angular/router'
@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {
  constructor (private authService: AuthService, private router: Router) {}
  
    isLoggedIn() : boolean {
      return this.authService.isLoggedIn();
    }
    
    logout() {
      this.authService.logout();
      
    }
    changePassword() {
      this.router.navigate(['/changepassword']);
    }
  // dropdown buttons
  public status: { isopen } = { isopen: false };
  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/components/app-header/app-header.component.ts